module.exports = __webpack_public_path__ + "static/activities-db9d95b49abc7816eee512bc1b678fce.svg";